import { ProtocolForm } from '@lidea/plots/shared/ui';
import { useFilters } from '@lidea/shared/data-access/core';
import { usePlot } from '@lidea/shared/data-access/plots';
import { ModalPage } from '@lidea/shared/ui/layout';
import { ProtocolFormValues } from '@lidea/shared/util/types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface EditProtocolModalProps {
  plotId: number;
  dismiss: (data: ProtocolFormValues | null, role: string) => void;
  onSubmit: (e: ProtocolFormValues) => void;
}

const EditProtocolModal: React.FC<EditProtocolModalProps> = (props) => {
  const { t } = useTranslation(['common', 'plot'], { useSuspense: false });
  const { filtersAsOptions } = useFilters();
  const plot = usePlot(props.plotId);

  const initialValues = useMemo(() => {
    if (!plot.data) {
      return undefined;
    }
    const { protocol, geosector } = plot.data.properties;
    return {
      ...protocol,
      geosector:
        typeof geosector === 'number' ? geosector : geosector?.id,
    };
  }, [plot.data]);

  const formKey = useMemo(() => {
    const geosectorId =
      typeof plot.data?.properties.geosector === 'number'
        ? plot.data.properties.geosector
        : plot.data?.properties.geosector?.id;
    return `${props.plotId}-${geosectorId ?? 'none'}`;
  }, [plot.data, props.plotId]);

  return (
    <ModalPage
      title={t('plot:edit_protocol')}
      onClose={() => props.dismiss(null, 'cancel')}
    >
      {initialValues ? (
        <ProtocolForm
          key={formKey}
          geosectorField={filtersAsOptions?.geosector}
          useIonicActions
          i18n={{
            confirm: t('common:validate'),
            cancel: t('common:cancel'),
          }}
          initialValues={initialValues}
          onCancel={() => props.dismiss(null, 'cancel')}
          onSubmit={props.onSubmit}
        />
      ) : null}
    </ModalPage>
  );
};

export default EditProtocolModal;
